//@flow
import {useSelector} from "react-redux";
import {parseOrder} from "../../types/order/parse";
import {createSelector} from "reselect";

const selectById = createSelector(
	[
		(state) => state.order.get('byId'),
		(state) => state.currentUser.get('language'),
		(state, id) => id
	],
	(byId, language, id) => {
		return parseOrder(byId.get(id), language)
	}
)

const selectRawById = createSelector(
	[
		(state) => state.order.get('rawById'),
		(state) => state.currentUser.get('language'),
		(state, id) => id
	],
	(rawById, language, id) => {
		return parseOrder(rawById.get(id), language)
	}
)

const useOrderDetailsData = (id) => {
	const order = useSelector(state => selectById(state, id))
	const rawOrder = useSelector(state => selectRawById(state, id))
	return {
		order,
		rawOrder
	}
}

export default useOrderDetailsData